import { districtPropertylist } from "@services";
import { PropertyStatePayload, districtAPIIntrface } from "@interface";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fatchDistrictProperty = createAsyncThunk(
    '/',
    async (payload: districtAPIIntrface, { rejectWithValue }) => {
        try {
            const response = await districtPropertylist(payload);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const SLICE_NAME = "districtProperty";

const initialState: PropertyStatePayload = {
    data: null, loading: false, error: null
};

export const districtSlice = createSlice({
    name: SLICE_NAME,
    initialState,
    reducers: {
        resetDistrictProperty: (state) => {
            state = initialState;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fatchDistrictProperty.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fatchDistrictProperty.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fatchDistrictProperty.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { resetDistrictProperty } = districtSlice.actions;